/** Категория расширения для визуала бейджа (градиент/цвет). */
export function getAttachmentBadgeCategory(filename: string): string {
  const raw = filename.split('.').pop()?.toLowerCase() ?? '';
  if (!raw || raw === filename.toLowerCase()) return 'generic';
  if (raw === 'pdf') return 'pdf';
  if (['doc', 'docx', 'odt', 'rtf'].includes(raw)) return 'doc';
  if (['xls', 'xlsx', 'csv', 'ods'].includes(raw)) return 'sheet';
  if (['ppt', 'pptx', 'key'].includes(raw)) return 'slides';
  if (['zip', 'rar', '7z', 'tar', 'gz', 'bz2'].includes(raw)) return 'archive';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'heic', 'avif'].includes(raw)) return 'image';
  if (
    ['js', 'ts', 'tsx', 'jsx', 'py', 'rs', 'go', 'java', 'c', 'cpp', 'h', 'css', 'html', 'json', 'md', 'yml', 'yaml', 'vue', 'svelte'].includes(
      raw
    )
  )
    return 'code';
  if (['mp4', 'mov', 'avi', 'webm', 'mkv'].includes(raw)) return 'video';
  if (['mp3', 'wav', 'flac', 'aac', 'm4a', 'ogg'].includes(raw)) return 'audio';
  return 'generic';
}

export function getFileExtensionLabel(filename: string): string {
  const parts = filename.split('.');
  if (parts.length < 2) return '';
  return parts[parts.length - 1].toUpperCase().slice(0, 5);
}
